import React from "react";
import { withRouter } from "react-router-dom";
import { labels } from "../../../localization/labels";
import ExtensionService from "../../../services/ExtensionService";
import { constants } from "../../../utils/Constants";
import RouteUtil from "../../../utils/RouteUtil";
import SecurityUtils from "../../../utils/SecurityUtils";
import { paths } from "../../paths";
import PageComponent from "../page/PageComponent";
import AdvancedSearch from "./AdvancedSearch";
import CommonUtil from "../../../utils/CommonUtil";
import { knowledge_item_ASPS } from "../page/AdvancedSearchComponent/advanced_search_parameters";
import { withKeycloak } from "@react-keycloak/web";

class AdvancedSearchContainer extends PageComponent {
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      advancedSearchParams:
        RouteUtil.getLocationParameter(props, "advancedSearchParams") ||
        knowledge_item_ASPS,
      extensions: [],
      classificationsFilter: SecurityUtils.geClassificationsByOperation(
        constants.OPERATION_READ
      ),
      reloadTags: false
    };
    this.extensionService = new ExtensionService(this.keycloak);
  }

  componentDidMount() {
    super.componentDidMount();
    this.loadExtensions();
  }

  componentDidUpdate() {
    if (this.isComponentRefresh()) {
      //it is refresh of the component, caused by onMenuItemClick in PageContainer, i.e. after side menu (same) item click
      this._resetInProgress = true;
      this.resetComponent();
      this._resetInProgress = false;
    }
  }

  loadExtensions = () => {
    this.prepareCall(
      this.extensionService.getEntities(
        undefined,
        this.sortInfo,
        this.onExtensionsLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onExtensionsLoad = data => {
    const extensions = CommonUtil.getDataContent(data) || [];
    this.setState({ extensions: extensions });
  };

  onChange = event => {
    const { advancedSearchParams } = this.state;
    advancedSearchParams[event.target.id].filterVal = event.target.value;
    this.setState({ advancedSearchParams });
  };

  handleAdvancedSearch = () => {
    this.changePath(paths.KNOWLEDGE_MANAGMENT, labels.knowledgeManagement, {
      advancedSearchParams: this.state.advancedSearchParams
    });
  };

  resetAdvancedSearchParams = () => {
    const { advancedSearchParams } = this.state;
    Object.keys(advancedSearchParams).forEach(function (key) {
      const advancedSearchParam = advancedSearchParams[key];
      advancedSearchParam.filterVal = undefined;
      advancedSearchParams[key] = advancedSearchParam;
    });
    this.setState({ reloadTags: true, advancedSearchParams });
  };

  onSelectClassification = classificationArray => {
    const { advancedSearchParams } = this.state;
    const classifications = advancedSearchParams.classifications;
    classifications.filterVal = [];

    if (classificationArray) {
      classifications.filterVal = classificationArray;
    }

    this.setState({
      advancedSearchParams: {
        ...this.state.advancedSearchParams,
        classifications: classifications
      }
    });
  };

  getComponentTitle = () => {
    return labels.advancedSearch;
  };

  reloadedTags = () => {
    this.setState({ reloadTags: false });
  };

  render() {
    return (
      <AdvancedSearch
        handleAdvancedSearch={this.handleAdvancedSearch}
        advancedSearchParams={this.state.advancedSearchParams}
        onChange={this.onChange}
        resetAdvancedSearchParams={this.resetAdvancedSearchParams}
        extensions={this.state.extensions}
        onSelectClassification={this.onSelectClassification}
        {...this.handlerProps()}
        classifications={
          this.state.advancedSearchParams.classifications.filterVal
        }
        classificationsFilter={this.state.classificationsFilter}
        reloadTags={this.state.reloadTags}
        reloadedTags={this.reloadedTags}
      />
    );
  }
}

export default withKeycloak(withRouter(AdvancedSearchContainer));
